export const UiTypes = {
  SET_ACTIVE_POINT: 'UI__SET_ACTIVE_POINT',
  SET_DRAGGED_POINT: 'UI__SET_DRAGGED_POINT',
}

export const setActivePoint = (index: any) => (dispatch: any) =>
  dispatch({
    type: UiTypes.SET_ACTIVE_POINT,
    payload: index,
  })

export const setDraggedPoint = (index: any) => (dispatch: any) =>
  dispatch({
    type: UiTypes.SET_DRAGGED_POINT,
    payload: index,
  })
